import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { LOCATION_CHANGE } from 'react-router-redux';
var CLEAR_ALL_BANNERS = 'classpass/banner_2/CLEAR_ALL_BANNERS';
export var ADD_BANNER = 'classpass/banner_2/ADD';
export var REMOVE_BANNERS = 'classpass/banner_2/REMOVE';
export var clearAllBanners = function clearAllBanners() {
  return {
    type: CLEAR_ALL_BANNERS
  };
};
export var removeBanner = function removeBanner() {
  for (var _len = arguments.length, bannerIds = new Array(_len), _key = 0; _key < _len; _key++) {
    bannerIds[_key] = arguments[_key];
  }

  return {
    type: REMOVE_BANNERS,
    data: bannerIds
  };
};
export var addBanner = function addBanner(category, component, props) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    type: ADD_BANNER,
    data: {
      id: options.id || (__TEST__ ? 1 : String(Math.round(Math.random() * 100000000))),
      category: category,
      component: component,
      props: props,
      options: _objectSpread({
        priority: 1
      }, options)
    }
  };
};
export var addAnnouncement = function addAnnouncement(id, component, props) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$priority = _ref.priority,
      priority = _ref$priority === void 0 ? 1 : _ref$priority,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 0 : _ref$timeout,
      _ref$removeAfterNavig = _ref.removeAfterNavigations,
      removeAfterNavigations = _ref$removeAfterNavig === void 0 ? null : _ref$removeAfterNavig,
      _ref$suppressible = _ref.suppressible,
      suppressible = _ref$suppressible === void 0 ? null : _ref$suppressible;

  return addBanner('announcement', component, props, {
    priority: priority,
    timeout: timeout,
    removeAfterNavigations: removeAfterNavigations,
    suppressible: suppressible,
    id: id
  });
};
export var addNotification = function addNotification(component, props) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _ref2$priority = _ref2.priority,
      priority = _ref2$priority === void 0 ? 1 : _ref2$priority,
      _ref2$timeout = _ref2.timeout,
      timeout = _ref2$timeout === void 0 ? 5000 : _ref2$timeout,
      _ref2$removeAfterNavi = _ref2.removeAfterNavigations,
      removeAfterNavigations = _ref2$removeAfterNavi === void 0 ? 1 : _ref2$removeAfterNavi,
      rest = _objectWithoutProperties(_ref2, ["priority", "timeout", "removeAfterNavigations"]);

  return addBanner('notification', component, props, _objectSpread({
    priority: priority,
    timeout: timeout,
    removeAfterNavigations: removeAfterNavigations
  }, rest));
};
export var addSuccessNotification = function addSuccessNotification(message, options) {
  return addNotification('SuccessNotification', {
    message: message
  }, options);
};
export var addFailureNotification = function addFailureNotification(message, options) {
  return addNotification('FailureNotification', {
    message: message
  }, options);
};
export var addGenericNotification = function addGenericNotification(message, options) {
  return addNotification('GenericNotification', {
    message: message
  }, options);
};
export var selectBannerToDisplay = function selectBannerToDisplay(category, state) {
  return state.banners.find(function (banner) {
    return banner.category === category;
  });
};
export var selectHasBannersQueued = function selectHasBannersQueued(state) {
  return !!state.banners.length;
};
var initialState = [];
export function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CLEAR_ALL_BANNERS:
      return [];

    case ADD_BANNER:
      {
        var _action$data = action.data,
            id = _action$data.id,
            options = _action$data.options,
            rest = _objectWithoutProperties(_action$data, ["id", "options"]);

        var seenIds = {};
        return state.concat(_objectSpread({
          id: id
        }, rest, options, {
          navigationsSinceAdded: 0
        })).reduce(function (banners, banner) {
          if (!(banner.id in seenIds)) {
            seenIds[banner.id] = true;
            banners.push(banner);
          }

          return banners;
        }, []).sort(function (a, b) {
          return b.priority - a.priority;
        });
      }

    case REMOVE_BANNERS:
      return state.filter(function (banner) {
        return !action.data.includes(banner.id);
      });

    case LOCATION_CHANGE:
      return state.map(function (banner) {
        return _objectSpread({}, banner, {
          navigationsSinceAdded: banner.navigationsSinceAdded + 1
        });
      }).filter(function (banner) {
        return !banner.removeAfterNavigations || banner.navigationsSinceAdded < banner.removeAfterNavigations;
      });

    default:
      return state;
  }
}